import React from "react";
import PropTypes from "prop-types";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Home from "./home/Home";
import Login from "./register_login/Login";

function Routing(props) {
  const {
    selectHome,
    addLead,
    errors,
    landing,
    quienes,
    inicio,
    faqs,
    anuncios,
    servicios,
    openTermsDialog,
    pushMessageToSnackbar,
    handleScrollClick,
    idioma,
    messages,
  } = props;

  return (
    <Routes>
      <Route
        path="*"
        element={
          <Home
            selectHome={selectHome}
            addLead={addLead}
            errors={errors}
            landing={landing}
            quienes={quienes}
            inicio={inicio}
            faqs={faqs}
            anuncios={anuncios}
            servicios={servicios}
            openTermsDialog={openTermsDialog}
            pushMessageToSnackbar={pushMessageToSnackbar}
            handleScrollClick={handleScrollClick}
            idioma={idioma}
            messages={messages}
          />
        }
      ></Route>
    </Routes>
  );
}

Routing.propTypes = {
  selectHome: PropTypes.func.isRequired,
  openTermsDialog: PropTypes.func.isRequired,
  addLead: PropTypes.func.isRequired,
  handleScrollClick: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  landing: PropTypes.object.isRequired,
  quienes: PropTypes.object.isRequired,
  inicio: PropTypes.object.isRequired,
  messages: PropTypes.object.isRequired,
  faqs: PropTypes.object.isRequired,
  anuncios: PropTypes.object.isRequired,
  servicios: PropTypes.object.isRequired,
  pushMessageToSnackbar: PropTypes.func,
  idioma: PropTypes.string.isRequired,
};

export default Routing;
